import { mapState } from "vuex";
import { Globals } from "../../global_constants/constants";
const msgSocket = window.io ? window.io(Globals.socketio_server_addr) : null;
const trSocket = null;
const chatSocket = null;
export default {
  loginMsgSocket: msgSocket,
  computed: {
    ...mapState("user", ["auth"])
  },
  data() {
    return {
     // loginMsgSocket: msgSocket,
      msgSocket: msgSocket,
      trSocket: trSocket,
      chatSocket: chatSocket
    };
  },
  methods: {}
};
